var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_239_33542",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_239_33542)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.4H10.2857V0H0V6.4Z",
    fill: "#083D7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7144 16H24.0001V9.59998H13.7144V16Z",
    fill: "#083D7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16H10.2857V9.59998H0V16Z",
    fill: "#DF1E35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7144 6.4H24.0001V0H13.7144V6.4Z",
    fill: "#DF1E35"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_239_33542",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7879 6.86863C10.1184 7.49347 10.1184 8.50653 10.7879 9.13137C11.4573 9.75621 12.5428 9.75621 13.2122 9.13137C13.8817 8.50653 13.8817 7.49347 13.2122 6.86863"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.3005 6.41375C9.36186 7.28981 9.36186 8.71019 10.3005 9.58625L11.2752 8.67649C10.8749 8.30288 10.8749 7.69712 11.2752 7.32351L10.3005 6.41375ZM10.3005 9.58625C11.2391 10.4623 12.761 10.4623 13.6996 9.58625L12.7249 8.67649C12.3246 9.05011 11.6755 9.05011 11.2752 8.67649L10.3005 9.58625ZM13.6996 9.58625C14.6382 8.71019 14.6382 7.28981 13.6996 6.41375L12.7249 7.32351C13.1252 7.69712 13.1252 8.30288 12.7249 8.67649L13.6996 9.58625Z",
    fill: "#0F6D1A",
    mask: "url(#path-7-inside-1_239_33542)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 8.53334C12.3157 8.53334 12.5716 8.29456 12.5716 8.00001C12.5716 7.70546 12.3157 7.46667 12.0001 7.46667C11.6845 7.46667 11.4287 7.70546 11.4287 8.00001C11.4287 8.29456 11.6845 8.53334 12.0001 8.53334Z",
    fill: "#042F60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDo);
export default __webpack_public_path__ + "static/media/DO.172aeb955b19e26d3e68db4e80c1a0f9.svg";
export { ForwardRef as ReactComponent };